const ecsJson = require('../../ecs.json')
export const production = ecsJson.environments.prod.env
export const OTEL_EXPORTER_OTLP_TRACES_ENDPOINT =
  'https://gto-ocp.icproxy.secp.c1.vanguard.com/v1/traces'
